"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'marketing-integration' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 90 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'marketing-integration' });
    }
    ;
    /**
    * @typedef {Object} embeddedCodeSaveErrorParams
    * @property {string} errorType - error_type
    * @property {string} integration_name - integration_name
    * @property {boolean} isPremium - is_premium on the moment of action
    * @property {GUID} msid - msid
    **/
    /**
     * Name: Embedded code save error. Evid: 123.
     * Event description: after click on save button, passed client validation,initiated  save,  but fail to save.
    
     * errorType - Type: string. Desc: error_type
     *
     * integration_name - Type: string. Desc: integration_name
     *
     * isPremium - Type: bool. Desc: is_premium on the moment of action
     *
     * msid - Type: guid. Desc: msid
     * @param {embeddedCodeSaveErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.embeddedCodeSaveError = function (params) {
        return this.bi.log(__assign({ evid: 123 }, params));
    };
    /**
    * @typedef {Object} gmbVerificationFlowProvidePossibleMethodsParams
    * @property {string} address_type - type of location {"physical address","service area","address+service area"}
    * @property {string} business_name - the bussiness name the user inserted
    * @property {string} business_type - the type of the business, new business or existing (claimable)
    * @property {string} bussiness_category - the category of the bussiness
    * @property {string} consumer_id - the id of the consumer (for now just GMB)
    * @property {string} google_acount_id - the google location group (could be wix google id, or NTT google id)
    * @property {string} google_location_id - the google id of the location (external)
    * @property {string} location_identifier - the internal id of the location
    * @property {string} method_possible - the method that is possible to the user to use (email,call,post)
    * @property {GUID} msid - msid
    * @property {string} verification_status - the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
    **/
    /**
     * Name: GMB - verification flow - provide possible methods. Evid: 1003.
     * Event description: server event when the platform provides possible methods to verify your business.
    
     * address_type - Type: string. Desc: type of location {"physical address","service area","address+service area"}
     *
     * business_name - Type: string. Desc: the bussiness name the user inserted
     *
     * business_type - Type: string. Desc: the type of the business, new business or existing (claimable)
     *
     * bussiness_category - Type: string. Desc: the category of the bussiness
     *
     * consumer_id - Type: string. Desc: the id of the consumer (for now just GMB)
     *
     * google_acount_id - Type: string. Desc: the google location group (could be wix google id, or NTT google id)
     *
     * google_location_id - Type: string. Desc: the google id of the location (external)
     *
     * location_identifier - Type: string. Desc: the internal id of the location
     *
     * method_possible - Type: string. Desc: the method that is possible to the user to use (email,call,post)
     *
     * msid - Type: guid. Desc: msid
     *
     * verification_status - Type: string. Desc: the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
     * @param {gmbVerificationFlowProvidePossibleMethodsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gmbVerificationFlowProvidePossibleMethods = function (params) {
        return this.bi.log(__assign({ evid: 1003 }, params));
    };
    /**
    * @typedef {Object} integrationModalFootNoteClickParams
    * @property {string} integration_name - integration name
    * @property {boolean} is_premium - is_premium
    * @property {string} modal_type - each modal will have a unique nameing
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration modal foot note click. Evid: 109.
     * Event description: foot note click.
    
     * integration_name - Type: string. Desc: integration name
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * modal_type - Type: string. Desc: each modal will have a unique nameing
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationModalFootNoteClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationModalFootNoteClick = function (params) {
        return this.bi.log(__assign({ evid: 109 }, params));
    };
    /**
    * @typedef {Object} integrationPageSetupButtonClickParams
    * @property {string} integration_name - integration name
    * @property {boolean} is_premium - is_premium
    * @property {string} location - button location - top,bottom
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration page setup button click. Evid: 105.
     * Event description: in the integration page - click on setup.
    
     * integration_name - Type: string. Desc: integration name
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * location - Type: string. Desc: button location - top,bottom
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationPageSetupButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationPageSetupButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 105 }, params));
    };
    /**
    * @typedef {Object} integrationClickParams
    * @property {string} integration_name - integration name
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration click. Evid: 103.
     * Event description: click on one of the integrations.
    
     * integration_name - Type: string. Desc: integration name
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationClick = function (params) {
        return this.bi.log(__assign({ evid: 103 }, params));
    };
    /**
    * @typedef {Object} gmbVerificationFlowVerifyFailedParams
    * @property {string} address_details - json with all the details of the address(country, street, zipcode ...)
    * @property {string} address_type - type of location {"physical address","service area","address+service area"}
    * @property {string} business_name - the bussiness name the user inserted
    * @property {string} business_type - the type of the business, new business or existing (claimable)
    * @property {string} bussiness_category - the category of the bussiness
    * @property {string} consumer_id - the id of the consumer (for now just GMB)
    * @property {string} error_data - full json of the error
    * @property {string} error_type - the type of the error
    * @property {string} google_acount_id - the google location group (could be wix google id, or NTT google id)
    * @property {string} google_location_id - the google id of the location (external)
    * @property {string} location_identifier - the internal id of the location
    * @property {GUID} msid - msid
    * @property {string} verfication_type - the type of the verification (call/text/email/post)
    * @property {string} verification_status - the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
    **/
    /**
     * Name: GMB - verification flow - verify failed. Evid: 1006.
     * Event description: when the user failed to verify his business (serer event).
    
     * address_details - Type: string. Desc: json with all the details of the address(country, street, zipcode ...)
     *
     * address_type - Type: string. Desc: type of location {"physical address","service area","address+service area"}
     *
     * business_name - Type: string. Desc: the bussiness name the user inserted
     *
     * business_type - Type: string. Desc: the type of the business, new business or existing (claimable)
     *
     * bussiness_category - Type: string. Desc: the category of the bussiness
     *
     * consumer_id - Type: string. Desc: the id of the consumer (for now just GMB)
     *
     * error_data - Type: string. Desc: full json of the error
     *
     * error_type - Type: string. Desc: the type of the error
     *
     * google_acount_id - Type: string. Desc: the google location group (could be wix google id, or NTT google id)
     *
     * google_location_id - Type: string. Desc: the google id of the location (external)
     *
     * location_identifier - Type: string. Desc: the internal id of the location
     *
     * msid - Type: guid. Desc: msid
     *
     * verfication_type - Type: string. Desc: the type of the verification (call/text/email/post)
     *
     * verification_status - Type: string. Desc: the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
     * @param {gmbVerificationFlowVerifyFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gmbVerificationFlowVerifyFailed = function (params) {
        return this.bi.log(__assign({ evid: 1006 }, params));
    };
    /**
    * @typedef {Object} mcIntegrationWixLabelSelectParams
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    * @property {string} wix_label_name - label key for internal labels, user define for custom labels
    **/
    /**
     * Name: mc integration - wix label select. Evid: 112.
     * Event description: choose from the wix dropdown for choosing wix label (contact group).
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     *
     * wix_label_name - Type: string. Desc: label key for internal labels, user define for custom labels
     * @param {mcIntegrationWixLabelSelectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mcIntegrationWixLabelSelect = function (params) {
        return this.bi.log(__assign({ evid: 112 }, params));
    };
    /**
    * @typedef {Object} gmbVerificationFlowVerificationCodeSentParams
    * @property {string} address_type - type of location {"physical address","service area","address+service area"}
    * @property {string} business_name - the bussiness name the user inserted
    * @property {string} business_type - the type of the business, new business or existing (claimable)
    * @property {string} bussiness_category - the category of the bussiness
    * @property {string} consumer_id - the id of the consumer (for now just GMB)
    * @property {string} google_acount_id - the google location group (could be wix google id, or NTT google id)
    * @property {string} google_location_id - the google id of the location (external)
    * @property {string} location_identifier - the internal id of the location
    * @property {GUID} msid - msid
    * @property {number} number_of_codes_sent - count of the codes sent in this verifacetion flow
    * @property {string} verfication_type - the type of the verification (call/text/email/post)
    * @property {string} verification_status - the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
    **/
    /**
     * Name: GMB - verification flow - verification code sent. Evid: 1004.
     * Event description: server event when the verificatrion code is being sent to the user.
    
     * address_type - Type: string. Desc: type of location {"physical address","service area","address+service area"}
     *
     * business_name - Type: string. Desc: the bussiness name the user inserted
     *
     * business_type - Type: string. Desc: the type of the business, new business or existing (claimable)
     *
     * bussiness_category - Type: string. Desc: the category of the bussiness
     *
     * consumer_id - Type: string. Desc: the id of the consumer (for now just GMB)
     *
     * google_acount_id - Type: string. Desc: the google location group (could be wix google id, or NTT google id)
     *
     * google_location_id - Type: string. Desc: the google id of the location (external)
     *
     * location_identifier - Type: string. Desc: the internal id of the location
     *
     * msid - Type: guid. Desc: msid
     *
     * number_of_codes_sent - Type: numeric. Desc: count of the codes sent in this verifacetion flow
     *
     * verfication_type - Type: string. Desc: the type of the verification (call/text/email/post)
     *
     * verification_status - Type: string. Desc: the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
     * @param {gmbVerificationFlowVerificationCodeSentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gmbVerificationFlowVerificationCodeSent = function (params) {
        return this.bi.log(__assign({ evid: 1004 }, params));
    };
    /*event 100 on project 'com.wixpress.promote.marketing-integration has no function name set, please set one in BI Catalog.*/
    /**
    * @typedef {Object} mailchimpCreateAnotherParams
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    **/
    /**
     * Name: mailchimp create another. Evid: 116.
     * Event description: create new connection.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     * @param {mailchimpCreateAnotherParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mailchimpCreateAnother = function (params) {
        return this.bi.log(__assign({ evid: 116 }, params));
    };
    /**
    * @typedef {Object} mcIntegrationMcListSelectParams
    * @property {boolean} is_premium - is_premium
    * @property {string} mc_list_id - unique value
    * @property {GUID} msid - msid
    **/
    /**
     * Name: mc integration - mc list select. Evid: 113.
     * Event description: choose from the mc dropdown for choosing mc list (contact group).
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * mc_list_id - Type: string. Desc: unique value
     *
     * msid - Type: guid. Desc: msid
     * @param {mcIntegrationMcListSelectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mcIntegrationMcListSelect = function (params) {
        return this.bi.log(__assign({ evid: 113 }, params));
    };
    /**
    * @typedef {Object} integrationModalCtaClickParams
    * @property {string} cta_type - refreash, close, go to mc, upgrade...
    * @property {string} integration_name - integration name
    * @property {boolean} is_premium - is_premium
    * @property {string} modal_type - each modal will have a unique nameing
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration modal cta click. Evid: 108.
     * Event description: when clicking on one of the modal ctas.
    
     * cta_type - Type: string. Desc: refreash, close, go to mc, upgrade...
     *
     * integration_name - Type: string. Desc: integration name
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * modal_type - Type: string. Desc: each modal will have a unique nameing
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationModalCtaClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationModalCtaClick = function (params) {
        return this.bi.log(__assign({ evid: 108 }, params));
    };
    /**
    * @typedef {Object} integrationPageMenuClickParams
    * @property {string} integration_name - integration_name
    * @property {boolean} isPremium - is_premium on the moment of action
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration page menu click. Evid: 124.
     * Event description: click on the menu button (3 dots) to open options.
    
     * integration_name - Type: string. Desc: integration_name
     *
     * isPremium - Type: bool. Desc: is_premium on the moment of action
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationPageMenuClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationPageMenuClick = function (params) {
        return this.bi.log(__assign({ evid: 124 }, params));
    };
    /**
    * @typedef {Object} nodeErrorParams
    * @property {string} data - json
    * @property {GUID} msid - msid
    * @property {string} type - reporting type
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Node Error. Evid: 3.
     * Event description: Node error reporting.
    
     * data - Type: string. Desc: json
     *
     * msid - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: reporting type
     *
     * uuid - Type: guid. Desc: uuid
     * @param {nodeErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.nodeError = function (params) {
        return this.bi.log(__assign({ evid: 3 }, params));
    };
    /**
    * @typedef {Object} mailchimpConnectSuccessParams
    * @property {boolean} is_premium - is_premium
    * @property {string} mc_list_id - unique value
    * @property {GUID} msid - msid
    * @property {string} wix_label_name - label key for internal labels, user define for custom labels
    **/
    /**
     * Name: mailchimp connect success. Evid: 115.
     * Event description: success connection.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * mc_list_id - Type: string. Desc: unique value
     *
     * msid - Type: guid. Desc: msid
     *
     * wix_label_name - Type: string. Desc: label key for internal labels, user define for custom labels
     * @param {mailchimpConnectSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mailchimpConnectSuccess = function (params) {
        return this.bi.log(__assign({ evid: 115 }, params));
    };
    /**
    * @typedef {Object} mcIntegrationModalTooltipCloseParams
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    * @property {string} tooltip_name - only new conacts, delete connection warning, connection not active
    **/
    /**
     * Name: mc integration -  modal tooltip close. Evid: 120.
     * Event description: click on the tolltip X to close.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     *
     * tooltip_name - Type: string. Desc: only new conacts, delete connection warning, connection not active
     * @param {mcIntegrationModalTooltipCloseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mcIntegrationModalTooltipClose = function (params) {
        return this.bi.log(__assign({ evid: 120 }, params));
    };
    /**
    * @typedef {Object} cookieConcentBannerSettingClickParams
    * @property {GUID} msid - msid
    **/
    /**
     * Name: Cookie Concent banner - setting click. Evid: 126.
     * Event description: when the user clicks to go to settings in the banner.
    
     * msid - Type: guid. Desc: msid
     * @param {cookieConcentBannerSettingClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookieConcentBannerSettingClick = function (params) {
        return this.bi.log(__assign({ evid: 126 }, params));
    };
    /**
    * @typedef {Object} embeddedCodeSaveSuccessParams
    * @property {string} integration_name - integration_name
    * @property {boolean} isPremium - is_premium on the moment of action
    * @property {GUID} msid - msid
    **/
    /**
     * Name: Embedded code save success. Evid: 122.
     * Event description: after click on save button, passed client validation, initiated  save, and success to save changes/edit.
    
     * integration_name - Type: string. Desc: integration_name
     *
     * isPremium - Type: bool. Desc: is_premium on the moment of action
     *
     * msid - Type: guid. Desc: msid
     * @param {embeddedCodeSaveSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.embeddedCodeSaveSuccess = function (params) {
        return this.bi.log(__assign({ evid: 122 }, params));
    };
    /**
    * @typedef {Object} gmbVerificationFlowVerifySuccessParams
    * @property {string} address_details - json with all the details of the address(country, street, zipcode ...)
    * @property {string} address_type - type of location {"physical address","service area","address+service area"}
    * @property {string} business_name - the bussiness name the user inserted
    * @property {string} business_type - the type of the business, new business or existing (claimable)
    * @property {string} bussiness_category - the category of the bussiness
    * @property {string} consumer_id - the id of the consumer (for now just GMB)
    * @property {string} google_acount_id - the google location group (could be wix google id, or NTT google id)
    * @property {string} google_location_id - the google id of the location (external)
    * @property {string} location_identifier - the internal id of the location
    * @property {GUID} msid - msid
    * @property {string} verfication_type - the type of the verification (call/text/email/post)
    * @property {string} verification_status - the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
    **/
    /**
     * Name: GMB - verification flow - verify success. Evid: 1005.
     * Event description: when the user verifies his bussiness successfully(server event).
    
     * address_details - Type: string. Desc: json with all the details of the address(country, street, zipcode ...)
     *
     * address_type - Type: string. Desc: type of location {"physical address","service area","address+service area"}
     *
     * business_name - Type: string. Desc: the bussiness name the user inserted
     *
     * business_type - Type: string. Desc: the type of the business, new business or existing (claimable)
     *
     * bussiness_category - Type: string. Desc: the category of the bussiness
     *
     * consumer_id - Type: string. Desc: the id of the consumer (for now just GMB)
     *
     * google_acount_id - Type: string. Desc: the google location group (could be wix google id, or NTT google id)
     *
     * google_location_id - Type: string. Desc: the google id of the location (external)
     *
     * location_identifier - Type: string. Desc: the internal id of the location
     *
     * msid - Type: guid. Desc: msid
     *
     * verfication_type - Type: string. Desc: the type of the verification (call/text/email/post)
     *
     * verification_status - Type: string. Desc: the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
     * @param {gmbVerificationFlowVerifySuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gmbVerificationFlowVerifySuccess = function (params) {
        return this.bi.log(__assign({ evid: 1005 }, params));
    };
    /**
    * @typedef {Object} mailchimpDeleteConnectionParams
    * @property {boolean} is_premium - is_premium
    * @property {string} mc_list_id - unique value
    * @property {GUID} msid - msid
    * @property {string} wix_label_name - label key for internal labels, user define for custom labels
    **/
    /**
     * Name: mailchimp delete connection. Evid: 117.
     * Event description: delete exist connection.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * mc_list_id - Type: string. Desc: unique value
     *
     * msid - Type: guid. Desc: msid
     *
     * wix_label_name - Type: string. Desc: label key for internal labels, user define for custom labels
     * @param {mailchimpDeleteConnectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mailchimpDeleteConnection = function (params) {
        return this.bi.log(__assign({ evid: 117 }, params));
    };
    /**
    * @typedef {Object} cookieConcentBannerLearnMoreClickParams
    * @property {GUID} msid - msid
    **/
    /**
     * Name: Cookie Concent banner - learn more click. Evid: 127.
     * Event description: when the user clicks on the learn more in the banner.
    
     * msid - Type: guid. Desc: msid
     * @param {cookieConcentBannerLearnMoreClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookieConcentBannerLearnMoreClick = function (params) {
        return this.bi.log(__assign({ evid: 127 }, params));
    };
    /**
    * @typedef {Object} openAppParams
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    * @property {string} referral_info - source for open app
    **/
    /**
     * Name: open app. Evid: 101.
     * Event description: will be fired always when this app is loaded.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     *
     * referral_info - Type: string. Desc: source for open app
     * @param {openAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.openApp = function (params) {
        return this.bi.log(__assign({ evid: 101 }, params));
    };
    /**
    * @typedef {Object} mailchimpConnectClickParams
    * @property {boolean} is_premium - is_premium
    * @property {string} mc_list_id - unique value
    * @property {GUID} msid - msid
    * @property {string} wix_label_name - label key for internal labels, user define for custom labels
    **/
    /**
     * Name: mailchimp connect click. Evid: 114.
     * Event description: click to connect connection.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * mc_list_id - Type: string. Desc: unique value
     *
     * msid - Type: guid. Desc: msid
     *
     * wix_label_name - Type: string. Desc: label key for internal labels, user define for custom labels
     * @param {mailchimpConnectClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mailchimpConnectClick = function (params) {
        return this.bi.log(__assign({ evid: 114 }, params));
    };
    /**
    * @typedef {Object} gmbImprotGoogleLocationSuccressParams
    * @property {string} consumer_id - the id of the consumer (for now just GMB)
    * @property {string} google_acount_id - the google location group (could be wix google id, or NTT google id)
    * @property {string} location_identifier - the internal id of the location
    * @property {GUID} msid - msid
    **/
    /**
     * Name: GMB - import google location success. Evid: 1010.
     * Event description: server event when the user succerssfully imports a location.
    
     * consumer_id - Type: string. Desc: the id of the consumer (for now just GMB)
     *
     * google_acount_id - Type: string. Desc: the google location group (could be wix google id, or NTT google id)
     *
     * location_identifier - Type: string. Desc: the internal id of the location
     *
     * msid - Type: guid. Desc: msid
     * @param {gmbImprotGoogleLocationSuccressParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gmbImprotGoogleLocationSuccress = function (params) {
        return this.bi.log(__assign({ evid: 1010 }, params));
    };
    /**
    * @typedef {Object} integrationModalCloseParams
    * @property {string} integration_name - integration name
    * @property {boolean} is_premium - is_premium
    * @property {string} modal_type - each modal will have a unique nameing
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration modal close click. Evid: 110.
     * Event description: click that close the modal from  the X.
    
     * integration_name - Type: string. Desc: integration name
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * modal_type - Type: string. Desc: each modal will have a unique nameing
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationModalCloseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationModalClose = function (params) {
        return this.bi.log(__assign({ evid: 110 }, params));
    };
    /**
    * @typedef {Object} mcIntegrationModalTooltipLinkParams
    * @property {boolean} is_premium - is_premium
    * @property {string} link_type - close, link to article
    * @property {GUID} msid - msid
    * @property {string} tooltip_name - only new conacts, delete connection warning, connection not active
    **/
    /**
     * Name: mc integration -  modal tooltip link. Evid: 119.
     * Event description: click on on of the links in the tooltip.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * link_type - Type: string. Desc: close, link to article
     *
     * msid - Type: guid. Desc: msid
     *
     * tooltip_name - Type: string. Desc: only new conacts, delete connection warning, connection not active
     * @param {mcIntegrationModalTooltipLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mcIntegrationModalTooltipLink = function (params) {
        return this.bi.log(__assign({ evid: 119 }, params));
    };
    /**
    * @typedef {Object} integrationModalClosedParams
    * @property {string} data - json with specific data for the modul. MC modal will send the final connections
    * @property {string} integration_name - integration name
    * @property {boolean} is_premium - is_premium
    * @property {string} modal_type - each modal will have a unique nameing
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration modal closed. Evid: 107.
     * Event description: when ever the integration modal is been closed.
    
     * data - Type: string. Desc: json with specific data for the modul. MC modal will send the final connections
     *
     * integration_name - Type: string. Desc: integration name
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * modal_type - Type: string. Desc: each modal will have a unique nameing
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationModalClosedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationModalClosed = function (params) {
        return this.bi.log(__assign({ evid: 107 }, params));
    };
    /**
    * @typedef {Object} integrationPageViewParams
    * @property {string} integration_name - integration name
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration page view. Evid: 104.
     * Event description: after click on integration  - the integration view is loaded.
    
     * integration_name - Type: string. Desc: integration name
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationPageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationPageView = function (params) {
        return this.bi.log(__assign({ evid: 104 }, params));
    };
    /**
    * @typedef {Object} gmbReviewsPageActionSuccessParams
    * @property {string} action - the name of the action
    * @property {string} consumer_id - the id of the consumer (for now just GMB)
    * @property {string} google_acount_id - the google location group (could be wix google id, or NTT google id)
    * @property {string} location_identifier - the internal id of the location
    * @property {GUID} msid - msid
    **/
    /**
     * Name: GMB - reviews page - action success. Evid: 1009.
     * Event description: when the action the user tried to do completed succesfully (edit,reply,delete).
    
     * action - Type: string. Desc: the name of the action
     *
     * consumer_id - Type: string. Desc: the id of the consumer (for now just GMB)
     *
     * google_acount_id - Type: string. Desc: the google location group (could be wix google id, or NTT google id)
     *
     * location_identifier - Type: string. Desc: the internal id of the location
     *
     * msid - Type: guid. Desc: msid
     * @param {gmbReviewsPageActionSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gmbReviewsPageActionSuccess = function (params) {
        return this.bi.log(__assign({ evid: 1009 }, params));
    };
    /**
    * @typedef {Object} gmbEditGoogleLocationSuccessParams
    * @property {string} address_type - address_type
    * @property {string} business_name - the bussiness name the user inserted
    * @property {string} bussiness_category - the category of the bussiness
    * @property {string} consumer_id - the id of the consumer (for now just GMB)
    * @property {string} google_acount_id - the google location group (could be wix google id, or NTT google id)
    * @property {string} google_location_id - the google id of the location (external)
    * @property {string} location_details - json with full data about: address and category.
    other fields on a status "exists/non exists"
    * @property {string} location_identifier - the internal id of the location
    * @property {GUID} msid - msid
    * @property {string} verification_status - the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
    **/
    /**
     * Name: GMB - edit google location success. Evid: 1002.
     * Event description: server event when edit new google location.
    
     * address_type - Type: string. Desc: address_type
     *
     * business_name - Type: string. Desc: the bussiness name the user inserted
     *
     * bussiness_category - Type: string. Desc: the category of the bussiness
     *
     * consumer_id - Type: string. Desc: the id of the consumer (for now just GMB)
     *
     * google_acount_id - Type: string. Desc: the google location group (could be wix google id, or NTT google id)
     *
     * google_location_id - Type: string. Desc: the google id of the location (external)
     *
     * location_details - Type: string. Desc: json with full data about: address and category.
    other fields on a status "exists/non exists"
     *
     * location_identifier - Type: string. Desc: the internal id of the location
     *
     * msid - Type: guid. Desc: msid
     *
     * verification_status - Type: string. Desc: the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
     * @param {gmbEditGoogleLocationSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gmbEditGoogleLocationSuccess = function (params) {
        return this.bi.log(__assign({ evid: 1002 }, params));
    };
    /**
    * @typedef {Object} cookieConcentBannerDismissClickParams
    * @property {GUID} msid - msid
    **/
    /**
     * Name: Cookie Concent banner -dismiss click. Evid: 128.
     * Event description: when the user dismisses the banner.
    
     * msid - Type: guid. Desc: msid
     * @param {cookieConcentBannerDismissClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookieConcentBannerDismissClick = function (params) {
        return this.bi.log(__assign({ evid: 128 }, params));
    };
    /**
    * @typedef {Object} integrationPageMenuOptionClickParams
    * @property {string} integration_name - integration_name
    * @property {boolean} isPremium - is_premium on the moment of action
    * @property {GUID} msid - msid
    * @property {string} options - disable,enable, edit,delete
    **/
    /**
     * Name: integration page menu option click. Evid: 125.
     * Event description: click on one of the options from the 3 dots menu, for MC its only edit button.
    
     * integration_name - Type: string. Desc: integration_name
     *
     * isPremium - Type: bool. Desc: is_premium on the moment of action
     *
     * msid - Type: guid. Desc: msid
     *
     * options - Type: string. Desc: disable,enable, edit,delete
     * @param {integrationPageMenuOptionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationPageMenuOptionClick = function (params) {
        return this.bi.log(__assign({ evid: 125 }, params));
    };
    /**
    * @typedef {Object} integrationModalViewParams
    * @property {string} data - json with specific data for the madal. MC modul will send lists length, existing connections number
    * @property {string} integration_name - integration name
    * @property {boolean} is_premium - is_premium
    * @property {string} modal_type - mailchimp connections, mailchimp updrage, mailchimp no list,mailchimp loader
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration modal view. Evid: 106.
     * Event description: when clicking on the page cta, modal is open for integration.
    
     * data - Type: string. Desc: json with specific data for the madal. MC modul will send lists length, existing connections number
     *
     * integration_name - Type: string. Desc: integration name
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * modal_type - Type: string. Desc: mailchimp connections, mailchimp updrage, mailchimp no list,mailchimp loader
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationModalViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationModalView = function (params) {
        return this.bi.log(__assign({ evid: 106 }, params));
    };
    /**
    * @typedef {Object} integrationsHomePageViewParams
    * @property {string} banners_load - null
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integrations home page view. Evid: 102.
     * Event description: page loaded.
    
     * banners_load - Type: string.
     *
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationsHomePageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationsHomePageView = function (params) {
        return this.bi.log(__assign({ evid: 102 }, params));
    };
    /**
    * @typedef {Object} gmbCreateGoogleLocationSuccessParams
    * @property {string} address_type - type of location {"physical address","service area","address+service area"}
    * @property {string} business_name - the bussiness name the user inserted
    * @property {string} bussiness_category - the category of the bussiness
    * @property {string} consumer_id - the id of the consumer (for now just GMB)
    * @property {string} google_acount_id - the google location group (could be wix google id, or NTT google id)
    * @property {string} google_location_id - the google id of the location (external)
    * @property {string} location_details - json with full data about: address and category.
    other fields on a status "exists/non exists"
    * @property {string} location_identifier - the internal id of the location
    * @property {GUID} msid - msid
    * @property {string} verification_status - the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
    **/
    /**
     * Name: GMB - create google location success. Evid: 1001.
     * Event description: server event when creating new google location.
    
     * address_type - Type: string. Desc: type of location {"physical address","service area","address+service area"}
     *
     * business_name - Type: string. Desc: the bussiness name the user inserted
     *
     * bussiness_category - Type: string. Desc: the category of the bussiness
     *
     * consumer_id - Type: string. Desc: the id of the consumer (for now just GMB)
     *
     * google_acount_id - Type: string. Desc: the google location group (could be wix google id, or NTT google id)
     *
     * google_location_id - Type: string. Desc: the google id of the location (external)
     *
     * location_details - Type: string. Desc: json with full data about: address and category.
    other fields on a status "exists/non exists"
     *
     * location_identifier - Type: string. Desc: the internal id of the location
     *
     * msid - Type: guid. Desc: msid
     *
     * verification_status - Type: string. Desc: the status in the location regarding google (draft_exist/draft_new/verifaction_pending_phone/verifaction_pending_email/verifaction_pending_post/verified)
     * @param {gmbCreateGoogleLocationSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gmbCreateGoogleLocationSuccess = function (params) {
        return this.bi.log(__assign({ evid: 1001 }, params));
    };
    /**
    * @typedef {Object} integrationFbCopyLinkClickParams
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    **/
    /**
     * Name: integration fb copy link click. Evid: 111.
     * Event description: in the modal for FB catalog integration, click on the 'copy link'.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     * @param {integrationFbCopyLinkClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.integrationFbCopyLinkClick = function (params) {
        return this.bi.log(__assign({ evid: 111 }, params));
    };
    /**
    * @typedef {Object} embeddedCodeSaveInitiateParams
    * @property {string} integration_name - integration_name
    * @property {boolean} isPremium - is_premium on the moment of action
    * @property {GUID} msid - msid
    **/
    /**
     * Name: Embedded code save initiate. Evid: 121.
     * Event description: after click on save button, passed client validation, when a save comand is initiated.
    
     * integration_name - Type: string. Desc: integration_name
     *
     * isPremium - Type: bool. Desc: is_premium on the moment of action
     *
     * msid - Type: guid. Desc: msid
     * @param {embeddedCodeSaveInitiateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.embeddedCodeSaveInitiate = function (params) {
        return this.bi.log(__assign({ evid: 121 }, params));
    };
    /**
    * @typedef {Object} mcIntegrationModalTooltipViewParams
    * @property {boolean} is_premium - is_premium
    * @property {GUID} msid - msid
    * @property {string} tooltip_name - only new conacts, delete connection warning, connection not active
    **/
    /**
     * Name: mc integration -  modal tooltip view. Evid: 118.
     * Event description: tooltip modal pops out - mouse over trigger.
    
     * is_premium - Type: bool. Desc: is_premium
     *
     * msid - Type: guid. Desc: msid
     *
     * tooltip_name - Type: string. Desc: only new conacts, delete connection warning, connection not active
     * @param {mcIntegrationModalTooltipViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mcIntegrationModalTooltipView = function (params) {
        return this.bi.log(__assign({ evid: 118 }, params));
    };
    /**
    * @typedef {Object} nodeReportParams
    * @property {string} data - json
    * @property {GUID} msid - msid
    * @property {string} type - reporting type
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Node Report. Evid: 2.
     * Event description: Node reporting.
    
     * data - Type: string. Desc: json
     *
     * msid - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: reporting type
     *
     * uuid - Type: guid. Desc: uuid
     * @param {nodeReportParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.nodeReport = function (params) {
        return this.bi.log(__assign({ evid: 2 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 90,
        endpoint: 'marketing-integration'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map